import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useUI } from '../../context/UIContext'; // <-- IMPORT UI CONTEXT
import { PersonCircle, BoxArrowRight, Bell, Envelope,List  } from 'react-bootstrap-icons';
import { Dropdown, Badge, Button  } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'; // <-- IMPORT useNavigate
import '../../App.css';

const Header = () => {
    const { user, logout } = useAuth();
    const { toggleSidebar } = useUI(); // <-- USE THE TOGGLE FUNCTION
    const navigate = useNavigate(); // <-- Initialize the hook

  return (
    // <header className="app-header d-flex align-items-center justify-content-end">
    <header className="app-header d-flex align-items-center justify-content-between">
         {/* HAMBURGER MENU */}
        <Button variant="light" onClick={toggleSidebar} className="border-0 me-3">
            <List size={24} />
        </Button>
        {/* Placeholder icons for a more complete look */}
        <div className="d-flex align-items-center">
            <div className="me-4 position-relative">
                <Envelope size={20} />
                <Badge pill bg="warning" className="position-absolute top-0 start-100 translate-middle" style={{fontSize: '0.6em'}}>3</Badge>
            </div>
            <div className="me-4 position-relative">
                <Bell size={20} />
                <Badge pill bg="danger" className="position-absolute top-0 start-100 translate-middle" style={{fontSize: '0.6em'}}>1</Badge>
            </div>

            <Dropdown align="end">
                <Dropdown.Toggle id="user-dropdown" className="d-flex align-items-center user-dropdown-toggle">
                    <span className="me-2">{user?.name || 'User'}</span>
                    <PersonCircle size={28} />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.ItemText>
                        <strong>{user?.role}</strong><br />
                        <small className="text-muted">{user?.email}</small>
                    </Dropdown.ItemText>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={() => navigate('/profile')}>My Profile</Dropdown.Item>
                    <Dropdown.Item onClick={() => alert('Settings page not yet implemented.')}>Settings</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={logout} className="text-danger">
                        <BoxArrowRight className="me-2" /> Logout
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    </header>
  );
};

export default Header;